import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cn } from '@bridebook/aura';

export const RoundedModalOverlay = forwardRef<
  ElementRef<typeof DialogPrimitive.Overlay>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, children, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    data-slot="rounded-modal-overlay"
    className={cn(
      'fixed inset-0 z-50 bg-navy-growth/70 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0',
      className,
    )}
    {...props}>
    {children}
  </DialogPrimitive.Overlay>
));
RoundedModalOverlay.displayName = 'RoundedModalOverlay';
